export const queryKeys = {
  colleges: {
    all: ["colleges"] as const,
  },
  collegeLinks: {
    all: ["college-links"] as const,
  },
  attendance: {
    all: ["attendance"] as const,
    summary: () => [...queryKeys.attendance.all, "summary"] as const,
    history: (courseCode?: string) =>
      [...queryKeys.attendance.all, "history", courseCode] as const,
    projection: () => [...queryKeys.attendance.all, "projection"] as const,
  },
  timetable: {
    all: ["timetable"] as const,
    full: () => [...queryKeys.timetable.all, "full"] as const,
    today: () => [...queryKeys.timetable.all, "today"] as const,
    week: (startDate: string) =>
      [...queryKeys.timetable.all, "week", startDate] as const,
  },
  marks: {
    all: ["marks"] as const,
    list: (semester?: number | string, examType?: string) =>
      [...queryKeys.marks.all, "list", semester, examType] as const,
    summary: () => [...queryKeys.marks.all, "summary"] as const,
  },
  internalMarks: {
    all: ["internal-marks"] as const,
    list: (semester?: number, examType?: string) =>
      [...queryKeys.internalMarks.all, "list", semester, examType] as const,
  },
  courses: {
    all: ["courses"] as const,
  },
  notifications: {
    all: ["notifications"] as const,
    list: (page?: number) =>
      [...queryKeys.notifications.all, "list", page] as const,
  },
  biometric: {
    all: ["biometric"] as const,
    history: () => [...queryKeys.biometric.all, "history"] as const,
  },
  reminders: {
    all: ["reminders"] as const,
    list: () => [...queryKeys.reminders.all, "list"] as const,
  },
  datesheet: {
    all: ["datesheet"] as const,
    list: () => [...queryKeys.datesheet.all, "list"] as const,
  },
  profile: {
    all: ["profile"] as const,
  },
} as const;
